import HistorialInventarioService from 'src/modules/historialInventario/historialInventarioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'HISTORIALINVENTARIO_VIEW';

const historialInventarioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: historialInventarioViewActions.FIND_STARTED,
      });

      const record = await HistorialInventarioService.find(id);

      dispatch({
        type: historialInventarioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: historialInventarioViewActions.FIND_ERROR,
      });

      getHistory().push('/historial-inventario');
    }
  },
};

export default historialInventarioViewActions;
